import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import {
  FilterStyledSideBarHeader,
  createStyledIndicatorButton,
} from "../../../common/StyledComponents/SideBarComponents";
import { useTranslation } from "react-i18next";
import { colorSchemes, dueToCustomRange, fontSizeSchemes } from "../../../assets/commonFunction";
import DateRangePicker from "./DateRangePicker";
const classes = {
  chatBox1: {
    minWidth: "280px",
    backgroundColor: "#F9F8F8",
    height: "calc(100vh - 64px)",
    width: "calc(100% - 71.7em)",
    maxWidth: "500px",
    "@media only screen and (max-width:900px)": {
      flex: "1",
    },
  },
  chatBox2: {
    backgroundColor: "#F9F8F8",
    height: "calc(100vh - 64px)",
    minWidth: "250px",
    maxWidth: "350px",
    "@media only screen and (max-width:900px)": {
      flex: "1",
    },
  },
  headingText: {
    color: "black",
    fontSize: fontSizeSchemes.font18,
    fontWeight: "600",
    "@media (max-width: 63em)": {
      fontSize: "0.8rem",
    },
  },

  selectedItem: {
    // backgroundColor: "#183243",
    backgroundColor: "#E1E1E1",
    color: "#000",
  },
  nonselectedItem: {
    color: "#000",
  },
  taskmargin: {
    "@media only screen and (max-width:63em)": {
      marginLeft: "0 0px",
    },
    paddingTop: "0.3rem",
    paddingBottom: "0.3rem",
  },
};
const Filter = ({
  handleCheckedFilter,
  filterChecked,
  sidebarmenudata,
  handleClearFilter,
  handleApplyFilter,
  currentHomeIndexTab,
  setSideBarOpen,
  setSelectedDateRange,
  selectedDateRange
}) => {
  const [dateRangeAnchorEl, setDateRangeAnchorEl] = useState(null);
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const SmallActionButton = createStyledIndicatorButton("#DB0011");
  const boxStyle={
    paddingLeft: "1rem",
    paddingRight: "1rem",
    paddingTop: "0.1rem",
    paddingBottom: "0.1rem",
  }
  const buttonStyle = {
    ...boxStyle,
    padding: "0.08rem",
    textTransform: "none",
    background: colorSchemes.transparent,
    color: colorSchemes.black,
    borderRadius: "3px",
    border: `1px solid ${colorSchemes.black}`, 
    fontSize: fontSizeSchemes.font14,
    fontWeight: "400",
  }

  const handleDateRangeClose = () => {
    setDateRangeAnchorEl(null);
  };

  const handleDateRangeApply = (dateRange) => {
    setSelectedDateRange(dateRange);
    if (dateRange) {
      // Date range was applied, ensure checkbox is checked
      const existingFilter = filterChecked?.find(item => item?.value === "dueToCustomRange");
      if (!existingFilter) {
        handleCheckedFilter({
          target: {
            name: "Due in custom range",
            value: dueToCustomRange,
            checked: true
          }
        });
      }
    } else {
      // Date range was cleared, uncheck the checkbox
      handleCheckedFilter({
        target: {
          name: "Due in custom range",
          value: dueToCustomRange,
          checked: false
        }
      });
    }
  };

  const handleCustomDateRangeCheckbox = (event) => {
    const { checked } = event.target;
    if (checked) {
      // If checkbox is checked, open the date range picker
      setDateRangeAnchorEl(event.currentTarget);
    } else {
      // If checkbox is unchecked, remove the filter and clear date range
      setSelectedDateRange(null);
      // // Remove from filterChecked
      // const updatedFilters = filterChecked?.filter(item => item?.type !== "Due in custom range");
      // Call the parent handler to update the state
      handleCheckedFilter({
        target: {
          name: "Due in custom range",
          value: dueToCustomRange,
          checked: false
        }
      });
    }
  };

  return (
    <>
      <Box
        sx={{
          height: "72vh",
          overflow: "auto",
          backgroundColor: colorSchemes.boxBgColor,
          // 👇 Scrollbar styling
          "&::-webkit-scrollbar": {
            width: "3px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#B0B0B0",
            borderRadius: "8px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#888",
          },
        }}
      >
        {/* Filter */}
        <FilterStyledSideBarHeader
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            backgroundColor: "#F9F8F8", 
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            {/* <SmallActionButton onClick={()=>setSideBarOpen(false)} size="small" variant="contained">
              <FilterIcon src={Filtericon} />
            </SmallActionButton> */}
            <Box mr={"0.6rem"}>
              <Typography sx={classes.headingText} variant="h6">
                {appContent?.KEY235}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="center">
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={1}
              >
                <Button
                  onClick={() => handleClearFilter(null)}
                  sx={buttonStyle}
                  variant="filled"
                >
                  {appContent?.KEY10}
                </Button>

                <Button
                  onClick={() => handleApplyFilter(filterChecked)}
                  sx={buttonStyle}
                  variant="filled"
                >
                  {appContent?.KEY240}
                </Button>
              </Stack>
            </Box>
          </Box>
        </FilterStyledSideBarHeader>
        <Stack direction="column" justifyContent="space-between">
          <Stack>
            {sidebarmenudata?.map((item) => {
              const isDateRangeItem = item?.key === dueToCustomRange;
              const isChecked = isDateRangeItem
                ? filterChecked?.some(
                    (selectedItem) =>
                      selectedItem?.type === "Due in custom range" &&
                      selectedDateRange
                  )
                : filterChecked?.some(
                    (selectedItem) => selectedItem?.type === item?.label
                  );

              return (
                <Stack
                  key={item?.label + "sidebarmenudata"}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={3}
                  sx={{ ...boxStyle, ...classes.taskmargin }}
                >
                  <Typography
                    sx={{
                      fontSize: fontSizeSchemes.font13,
                      fontWeight: "400",
                      color: colorSchemes.black,
                    }}
                  >
                    {item?.label}
                  </Typography>
                  <Stack direction="row" alignItems="center">
                    <FormControlLabel
                      sx={{
                        alignItems: "flex-end",
                        marginRight: "-0.2rem",
                        justifyContent: "flex-end",
                      }}
                      checked={isChecked}
                      name={item?.label}
                      value={item?.key}
                      onChange={
                        isDateRangeItem
                          ? handleCustomDateRangeCheckbox
                          : handleCheckedFilter
                      }
                      control={
                        <Checkbox
                          checked={isChecked}
                          name={item?.label}
                          value={item?.value}
                          onChange={
                            isDateRangeItem
                              ? handleCustomDateRangeCheckbox
                              : handleCheckedFilter
                          }
                          icon={
                            <Box
                              sx={{
                                width: 25,
                                height: 25,
                                border: "0.5px solid #959a9eff",
                                backgroundColor: "#FFFFFF",
                              }}
                            />
                          }
                          checkedIcon={
                            <Box
                              sx={{
                                width: 25,
                                height: 25,
                                border: "1px solid #183243",
                                backgroundColor: "#FFFFFF",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  width: "8px",
                                  height: "15px",
                                  borderBottom: "2px solid #183243",
                                  borderRight: "2px solid #183243",
                                  transform: "rotate(45deg)",
                                  marginBottom: "2px",
                                }}
                              />
                            </Box>
                          }
                          sx={{
                            padding: 0,
                            "&:hover": {
                              backgroundColor: "transparent",
                            },
                          }}
                        />
                      }
                    />
                  </Stack>
                </Stack>
              );
            })}
          </Stack>
        </Stack>
      </Box>

      <DateRangePicker
        open={Boolean(dateRangeAnchorEl)}
        anchorEl={dateRangeAnchorEl}
        onClose={handleDateRangeClose}
        onApply={handleDateRangeApply}
        selectedDateRange={selectedDateRange}
        setSelectedDateRange={setSelectedDateRange}
      />
    </>
  );
};

export default Filter;
